module.exports = __webpack_public_path__ + "img/12-down-the-mtn_v8e.6f0a0581.png";